<template>
  <div class="d-flex flex-column sign-up">
    <app-header />
    <b-container class="flex-grow-1">
      <b-row class="justify-content-center">
        <b-col md="12" lg="8" class="pt-5 pb-5">
          <router-view />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { HeaderAlt as AppHeader } from '@/components/Header'

export default {
  name: 'SignUpFlow',

  components: {
    AppHeader
  }
}
</script>
